import { IconButton, MuiTooltip, ToggleOffIcon, ToggleOnIcon } from "@common";

const CommonToggleButton = ({
    checked = false,
    disabled = false,
    onClick,
    tooltip = "",
    size = "large",
    activeColor = "blue",
    inactiveColor = "grey",
    disabledColor = "#005d00"
}) => {
    return (
        <MuiTooltip title={tooltip}>
            <IconButton
                sx={{ cursor: disabled ? "default" : "pointer" }}
                disabled={disabled}
                onClick={(event) => {
                    event.stopPropagation();
                    onClick?.(event);
                }}
            >
                {checked ? (
                    <ToggleOnIcon
                        fontSize={size}
                        sx={{ color: disabled ? disabledColor : activeColor }}
                    />
                ) : (
                    <ToggleOffIcon
                        fontSize={size}
                        sx={{ color: inactiveColor }}
                    />
                )}
            </IconButton>
        </MuiTooltip>
    );
};

export default CommonToggleButton;